var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCameraProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 16C46.3734 16 44.88 15.0666 44.1334 13.6266L42.2134 9.75998C40.9867 7.33331 37.7867 5.33331 35.0667 5.33331H28.96C26.2134 5.33331 23.0134 7.33331 21.7867 9.75998L19.8667 13.6266C19.12 15.0666 17.6267 16 16 16C10.2134 16 5.62671 20.88 6.00004 26.64L7.38671 48.6666C7.70671 54.16 10.6667 58.6666 18.0267 58.6666H45.9734C53.3334 58.6666 56.2667 54.16 56.6134 48.6666L58 26.64C58.3734 20.88 53.7867 16 48 16ZM28 19.3333H36C37.0934 19.3333 38 20.24 38 21.3333C38 22.4266 37.0934 23.3333 36 23.3333H28C26.9067 23.3333 26 22.4266 26 21.3333C26 20.24 26.9067 19.3333 28 19.3333ZM32 48.32C27.04 48.32 22.9867 44.2933 22.9867 39.3066C22.9867 34.32 27.0134 30.2933 32 30.2933C36.9867 30.2933 41.0134 34.32 41.0134 39.3066C41.0134 44.2933 36.96 48.32 32 48.32Z",
    fill: "#92ABFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraProfile);
export default __webpack_public_path__ + "static/media/cameraProfile.c2616623fa79719927ede4a080952984.svg";
export { ForwardRef as ReactComponent };